<section class="w-full min-h-[100vh] __global_gradient_tmp__ overflow-hidden grid place-items-center">
  <img class="opacity-30 sm:w-full h-full sm:max-h-dvh object-fill sm:object-cover" src="assets/bkg_helipagos_metal.png"
    alt="Bkg helipagos metal" loading="eager" />
  <section hlmCard
    class="!w-[90%] md:w-[46.1%] min-w-[300px] max-w-[670px] sm:min-h-[32rem] rounded-3xl absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white min-h-[650px]">
    <div hlmCardHeader class="!pt-0">
      <img class="mx-auto pt-8 w-[80%]" src="assets/logo_helipagos_horizontal.svg" alt="Logo helipagos horizontal" />
      <h3 hlmCardTitle class="text-xl !mt-0 !font-normal sm:text-2xl text-gray-500 text-center">
        {{ 'auth.login.view_header' | translate }}
      </h3>
    </div>
    <h2 class="text-center text-2xl pt-12 !w-[80%] mx-auto">
      {{ headerTXT() }}
    </h2>
    <section hlmCardContent class="transition-all !w-[80%] mx-auto pt-4">
      <ng-content></ng-content>
      <section hlmCardFooter class="!w-full mx-auto !px-0 !py-5 grid gap-[1rem] !pb-8">
        <button (click)="btnClick.emit()" hlmBtn [disabled]="loading() || disabled()"
          class="!w-full p-[0.5rem] text-md flex gap-2 items-center">
          @if (loading() || redirecting()) {
            @if(loading()){
              <span>Cargando</span>
            }
            @if(redirecting()){
              <span>Redireccionando</span>
            }
          <hlm-icon name="lucideLoader2" size="sm" class="mr-2 animate-spin" />
          } @else {
          {{ btnLabel() }}
          }
       </button>

        @if(linkLabel()){
        <button (click)="linkClick.emit()" hlmBtn variant="link"
          class="!w-full text-accent-foreground font-normal opacity-80 !ml-0 p-[0.5rem] text-md">
          {{ linkLabel() }}
        </button>

        }

        <div class="h-[1px] bg-slate-300"></div>
        <p class="text-center text-slate-700 !text-xl !m-0 !p-0">
          {{ 'auth.login.view_no_account' | translate }}
        </p>
        <a href="https://www.helipagos.com/es/contact" hlmBtn variant="tertiary-outline"
          class="!border-accent-foreground !w-4/6 !text-accent-foreground !mx-auto hover:!text-white hover:border-white hover:bg-accent-foreground">
          {{ 'auth.login.begin_now' | translate }}
        </a>
      </section>
    </section>
  </section>
</section>
